import { Automation } from 'features/Automations/types';
import { BaseNimbleAPI } from './baseAPI';
import { AxiosResponse } from 'axios';

class AutomationsAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/automations' };
  }

  async getAutomations(roleId: number | null) {
    const url = `?role_id=${roleId}`;
    const response: AxiosResponse = await this.get(url);
    return response.data;
  }

  async save(automations: Automation[], roleId: number) {
    const url = `?role_id=${roleId}`;
    const response = await this.put(url, automations);
    return response.data;
  }
}

export default new AutomationsAPI();
